import { getCookie, removeCookie, setCookie } from 'typescript-cookie';
import { AnyClass, EventEmitterMixin, resolve, fromJson, toJson, fromBase64, toBase64 } from '@afz/base-library';
import { DEFAULT_COOKIE_KEY, DEFAULT_COOKIE_PATH, DEFAULT_COOKIE_CHECK_INTERVAL } from '../constants.js';
import { createSessionToken } from '../crypto.js';
import { EmptyCryptoKeyError, ExpiredSessionError, SessionAlreadyStartedError, SessionNotFoundError, SessionUserAccountMismatchError, } from '../error/mod.js';
export class DefaultAuthClient extends EventEmitterMixin(AnyClass) {
    options;
    session_;
    sessionPolling_ = 0;
    checkSession_(userAccount) {
        const raw = getCookie(this.options.cookieKey ?? DEFAULT_COOKIE_KEY);
        this.session_ = raw ? fromJson(fromBase64(raw) ?? undefined) : undefined;
        let error;
        if (!this.session_) {
            if (userAccount) {
                error = new ExpiredSessionError(`Sessión de usuario "${userAccount.userName}" caducada`);
            }
            else {
                error = new SessionNotFoundError();
            }
        }
        else if (userAccount && this.session_.userAccount && userAccount.id === this.session_.userAccount.id) {
            error = new SessionUserAccountMismatchError(`Cuenta de usuario actual "${userAccount.userName}" no coincide con la cuenta de usuario "${this.session_.userAccount.userName}" iniciada en la sessión`);
        }
        this.emit('Auth:SessionChecked', error ?? this.session_);
        return error;
    }
    redirectOnExpired_() {
        if (window?.location?.href && this.options.redirectToOnSessionExpired) {
            this.options.redirectToOnSessionExpired.searchParams.set('r', toBase64(window.location.href));
            window.location.href = this.options.redirectToOnSessionExpired.toString();
        }
    }
    constructor(options) {
        super();
        this.options = options;
    }
    get session() {
        return this.session_;
    }
    get userAccount() {
        return this.session_?.userAccount;
    }
    async createSessionRequest(userName, passphrase) {
        if (!this.options.cryptoKey) {
            return new EmptyCryptoKeyError();
        }
        return { token: await createSessionToken(userName, passphrase, this.options.cryptoKey) };
    }
    setLocalSession(session) {
        if (!session || !this.options.cookieKey) {
            return;
        }
        setCookie(this.options.cookieKey, toBase64(toJson(session)), {
            domain: this.options.cookieDomain,
            path: this.options.cookiePath,
            expires: this.options.cookieDuration
                ? new Date(new Date().getTime() + this.options.cookieDuration.toMillis())
                : undefined,
            secure: this.options.cookieSecure,
            sameSite: this.options.cookieSameSite,
        });
        this.checkSession_();
    }
    openSession() {
        if (this.sessionPolling_) {
            return resolve(new SessionAlreadyStartedError());
        }
        const error = this.checkSession_();
        if (error) {
            if (!this.options.noRedirectOnSessionExpired) {
                this.redirectOnExpired_();
            }
            return resolve(error);
        }
        this.sessionPolling_ = setInterval(() => this.checkSession(), (this.options.checkInterval ?? DEFAULT_COOKIE_CHECK_INTERVAL).toMillis());
        this.emit('Auth:SessionOpened', this.session_);
        return resolve(this.session_);
    }
    checkSession() {
        const error = this.checkSession_();
        if (error) {
            void this.closeSession(error);
        }
        return resolve(error);
    }
    closeSession(cause) {
        if (!this.sessionPolling_) {
            return resolve();
        }
        clearInterval(this.sessionPolling_);
        this.sessionPolling_ = 0;
        this.session_ = undefined;
        removeCookie(this.options.cookieKey ?? DEFAULT_COOKIE_KEY, {
            path: this.options.cookiePath ?? DEFAULT_COOKIE_PATH,
        });
        this.emit('Auth:SessionClosed', cause);
        if (!this.options.noRedirectOnSessionExpired) {
            this.redirectOnExpired_();
        }
        return resolve();
    }
}
//# sourceMappingURL=_default_auth_client.js.map